import type { FC } from 'react';
import React from 'react';
import { Container } from '@mui/material';
import { HeaderBreadcrumbs, Stack } from '@pflegenavi/web-components';
import { spAppMainPages } from '@pflegenavi/frontend/routing';
import { useTranslation } from 'react-i18next';
import { useInitializeResidents } from '../hooks/useUnitializeResidents';
import { useGetPayoutsPhoenix } from '@pflegenavi/service-provider-frontend/api';
import { PayoutsTable } from '../components/payouts/PayoutsTable';
import { PayoutTabValues } from '../components/payouts/types';
import { OpenItemsDownload } from '../components/payouts/OpenItemsDownload';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface DashboardPageProps {}

function mapTabFilterValue(tabFilterValue: PayoutTabValues) {
  switch (tabFilterValue) {
    case PayoutTabValues.All:
      return undefined;
    case PayoutTabValues.Paid:
      return 'SUCCEEDED';
    case PayoutTabValues.Failed:
      return 'FAILED';
    case PayoutTabValues.Pending:
      return 'CREATED';
    default:
      return undefined;
  }
}

export const PayoutsPage: FC<DashboardPageProps> = () => {
  const { t } = useTranslation();

  useInitializeResidents();

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);

  const [tabFilterValue, setTabFilterValue] = React.useState(
    PayoutTabValues.All
  );

  const { data: payouts, isLoading } = useGetPayoutsPhoenix({
    params: {
      page,
      pageSize,
      state: mapTabFilterValue(tabFilterValue),
    },
  });

  return (
    <Container sx={{ maxWidth: 1400 }}>
      <HeaderBreadcrumbs
        heading={t('dashboard.main')}
        links={[
          {
            name: t('dashboard.main'),
            href: spAppMainPages.DASHBOARD,
          },
          { name: t('payouts.main') },
        ]}
        action={<OpenItemsDownload />}
      />
      <Stack gap={3}>
        <PayoutsTable
          payouts={payouts}
          page={page}
          setPage={setPage}
          isLoading={isLoading}
          rowsPerPage={pageSize}
          setRowsPerPage={setPageSize}
          tabFilterValue={tabFilterValue}
          setTabFilterValue={setTabFilterValue}
          totalPages={payouts?.meta.total_count ?? 0} // TODO
          totalCount={payouts?.meta.total_count ?? 0}
        />
      </Stack>
    </Container>
  );
};
